<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <div class='mb25 s_flex_ali'>
        <span class='mr15'>
          <a-button type="primary" v-has:integralShopGiftCreate="()=> {$router.push('/integralShop/giftExchange/giftCreate?type=gift')}">
            <PlusOutlined />
            新建礼品兑换
          </a-button>
        </span>
      </div>
      <a-tabs @change="callback" v-model="active">
        <a-tab-pane :key="1" tab="已上架">
        </a-tab-pane>
        <a-tab-pane :key="0" tab="待上架">
        </a-tab-pane>
      </a-tabs>
      <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="礼品名称" name='name'>
          <a-input v-model:value="search.name" style='width:270px;margin-bottom: 15px;' placeholder="请输入关键词进行搜索" />
        </a-form-item>
        <a-form-item label="礼品类型" name='gift_type'>
          <a-select v-model:value="search.gift_type" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">实物</a-select-option>
            <a-select-option :value="2">消费卡券</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="礼品价格" name='price_type'>
          <a-select v-model:value="search.price_type" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">积分</a-select-option>
            <a-select-option :value="2">积分+现金</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="礼品分类" name='ex_gift_cate_id'>
          <a-cascader :options="loadData" v-model:value="search.ex_gift_cate_id" :field-names="{ label: 'name', value: 'id', children: 'child' }" placeholder="请选择礼品分类" allowClear />
        </a-form-item>
        <a-form-item label="礼品来源" name='product_type' v-if='search.gift_type == 1'>
          <a-select v-model:value="search.product_type" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">自有礼品</a-select-option>
            <a-select-option :value="2">产品库</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item name="">
          <a-checkbox-group v-model:value="checkbox" name="checkbox" :options="options" />
          <a-button type="primary" htmlType='submit' class="m-l-20">搜索</a-button>
          <a-button @click='reset' class="m-l-20">重置</a-button>
        </a-form-item>
      </a-form>
      <div class="m-b-20">
        <a-button class="m-r-15" type="primary" ghost v-has:integralShopGiftAllOff="offShelf" v-if='active == 1'>
          批量下架
        </a-button>
        <a-button class="m-r-15" type="primary" ghost v-has:integralShopGiftAllOff="pushShelf" v-else>
          批量上架
        </a-button>
        <a-button class="m-r-15" type="primary" ghost v-has:integralShopGiftAllSetCate="setCateAll">
          批量设置分类
        </a-button>
        <a-button class="m-r-15" type="primary" ghost v-has:integralShopGiftAllSetFreight="setShipping">
          批量设置运费模板
        </a-button>
      </div>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" class="tableFixBox" :scroll="{ x: 'max-content'}">
        <template v-slot:info="{ record }">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+record.image" alt="" style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>
              <p class="s_omit2" style='max-width:400px'>{{record.name}}</p>
            </template>
          </a-card-meta>
        </template>
        <template v-slot:price="{ record }">
          <span>{{record.point}}积分</span>
          <span v-if='record.price_type == 2'>+{{record.price}}元</span>
          <FormOutlined style="color: #999;margin-left: 5px;" v-has:integralShopGiftSetPrice='()=>{listItem = record;showEditPrice = true}' />
        </template>
        <template v-slot:use_exchange_num="{ record }">
          <p v-if="record.use_exchange_type==1 || record.use_exchange_type==3">每人{{record.use_exchange_num_json.date_type == 2 ?'每月':''}}限兑{{record.use_exchange_num_json.number}}件</p>
          <p v-if="record.use_exchange_type==0 || record.use_exchange_type==2">不限</p>
          <span class="m-r-5 s_c999">库存：{{record.use_exchange_num}}</span>
          <FormOutlined style="color: #999;" v-has:integralShopGiftSetNum='()=>{listItem = record;showEditStock = true}' />
        </template>
        <template v-slot:effective_time="{ record }">
          <div v-if='record.use_exchange_end_time'>
            <p>{{record.use_exchange_start_time}}</p>
            <span>{{record.use_exchange_end_time}}</span>
            <p v-if='record.use_exchange_status' class="text-ac s_cd41">（已过期）</p>
          </div>
          <p v-else>-</p>
        </template>
        <template v-slot:action="{ record }">
          <a v-has:integralShopGiftEdit="()=>$router.push({path:'/integralShop/giftExchange/giftCreate??type=gift&id',query:{id:record.id}})" href="javascript:;" class="m-r-5">编辑</a>
          <a v-has:integralShopGiftOff="()=>offShelf('single',record)" href="javascript:;" v-if='active==1' class="m-r-5">下架</a>
          <a v-has:integralShopGiftOff="()=>pushShelf('single',record)" href="javascript:;" v-if='active==0' class="m-r-5">上架</a>
          <a v-has:integralShopGiftUrl='()=>copy(record)' class='copy-btn m-r-5' :data-clipboard-text="http+'/#/pages/integralMarket/productDetail?brandId='+brand_id+'&id='+record.id" href="javascript:;">链接</a>

        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
    <a-modal  :keyboard="false" title="运费模板" centered v-model:visible="freightVideoVisible" :width='1300' :footer="null" destroyOnClose>
      <freight v-on:select="selectFreight" />
    </a-modal>

    <a-modal :keyboard="false" title="选择礼品类型" centered v-model:visible="showGiftType" destroyOnClose :footer="null">
      <div class="s_flex_ali">
        <div class="s_shou width50 text-ac" @click="()=> {$router.push('/integralShop/giftExchange/giftCreate?type=gift')}">
          <GiftOutlined style='font-size: 40px;color: #999;' />
          <p class="m-t-15">实物礼品</p>
        </div>
        <div class="s_shou width50 text-ac" @click="()=> {$router.push('/integralShop/giftExchange/giftCreate?type=card')}">
          <RedEnvelopeOutlined style='font-size: 40px;color: #999;' />
          <p class="m-t-15">消费卡券</p>
        </div>
      </div>
    </a-modal>
    <a-modal  :keyboard="false" title="修改兑换价格" centered v-model:visible="showEditPrice" :width='1300' :footer="null" destroyOnClose>
      <editPrice :item='listItem' v-on:submit='submitPrice'></editPrice>
    </a-modal>
    <a-modal  :keyboard="false" title="修改礼品库存" centered v-model:visible="showEditStock" :width='1300' :footer="null" destroyOnClose>
      <editStock :item='listItem' v-on:submit='submitStock'></editStock>
    </a-modal>
    <a-modal :keyboard="false" title="修改分类" centered v-model:visible="showEditCate" destroyOnClose @ok='editCate'>
      <a-cascader style="width:100%" v-model:value="valueCate" :options="loadData" placeholder="请选择产品分类" :field-names="{ label: 'name', value: 'id',children :'child' }" />
    </a-modal>
  </a-layout>
</template>
<script>
import Clipboard from "clipboard";
import {
  PlusOutlined,
  DownOutlined,
  RedEnvelopeOutlined,
  GiftOutlined,
  FormOutlined,
} from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { useTree } from "@/hooks/useTree.js";
import {
  exchangeGift,
  setDeliveryAll,
  getCategory,
  setExchangeState,
  editGiftPrice,
  editGiftStock,
  updateAllCate,
} from "@/api/integralShop";
import { json2fromData } from "@/utils/utils";
import { iscode } from "@/utils/app";
import editPrice from "./components/editPrice";
import editStock from "./components/editStock";
import store from "@/store";
// 初始化默认筛选项数值
let defSearch = {
  name: "",
  stock_num: "",
  page: 1,
  limit: 10,
  gift_type: "",
  price_type: "",
  ex_gift_cate_id: "",
  product_type: "",
  is_timing_status: "",
  is_sale_all: "",
  is_time_out: "",
};
var options = [
  // {
  //   label: "定时下架",
  //   value: "is_timing_status",
  // },
  {
    label: "已抢光",
    value: "is_sale_all",
  },
  {
    label: "已设置兑换权限",
    value: "is_use_exchange",
  },
  {
    label: "已过期",
    value: "is_time_out",
  },
];

export default {
  components: {
    PlusOutlined,
    // DownOutlined,
    RedEnvelopeOutlined,
    GiftOutlined,
    FormOutlined,
    editPrice,
    editStock,
  },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref();
    search.value = { ...defSearch };
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      http: "",
      brand_id: "",
      info: store.state.user.info,
      checkbox: [],
      listLoading: false,
      total: 1,
      loadData: [],
      status: 1,
      selectedRowKeys: [],
      freightVideoVisible: false, //设置运费模板弹窗
      showGiftType: false, //选择礼品类型模板
      showEditPrice: false,
      showEditStock: false,
      showEditCate: false,
      listItem: {},
      valueCate: "",
    });
    let columns = [
      {
        title: "礼品信息",
        dataIndex: "info",
        key: "info",
        slots: { customRender: "info" },
      },
      {
        title: "礼品类型",
        dataIndex: "gift_type_name",
        key: "gift_type_name",
      },
      {
        title: "分类",
        dataIndex: "category_name",
        key: "category_name",
      },
      {
        title: "兑换价格",
        dataIndex: "price",
        key: "price",
        slots: { customRender: "price" },
      },
      {
        title: "有效期",
        dataIndex: "effective_time",
        key: "effective_time",
        slots: { customRender: "effective_time" },
      },
      {
        title: "已兑换数量",
        dataIndex: "exchanged_num",
        key: "exchanged_num",
      },
      {
        title: "限兑数量",
        dataIndex: "use_exchange_num",
        key: "use_exchange_num",
        slots: { customRender: "use_exchange_num" },
      },
      {
        title: "创建时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "操作",
        key: "action",
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");

    const onSelectChange = (selectedRowKeys) => {
      state.selectedRowKeys = selectedRowKeys;
    };
    //修改价格
    const submitPrice = () => {
      state.showEditPrice = false;
      initData();
    };
    //修改库存
    const submitStock = () => {
      state.showEditStock = false;
      initData();
    };
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData();
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData();
    };
    // 获取分类
    const initCate = async () => {
      let result = await getCategory().then((res) => res.data);
      state.loadData = useTree(result.data);
      state.loadData.map(
        (v) => (v.disabled = v.child.length == 0 ? true : false)
      );
    };
    // tabs 点击
    const active = ref(1);
    const callback = (e) => {
      active.value = e;
      state.selectedRowKeys = [];
      reset();
      initData();
    };
    // 重置表单
    const form = ref();
    const reset = () => {
      search.value = defSearch;
      form.value.resetFields();
      state.checkbox = [];
      search.value.ex_gift_cate_id = "";
    };
    const initData = async () => {
      var json = JSON.parse(JSON.stringify(search.value));
      for (var i = 0; i < state.checkbox.length; i++) {
        json[state.checkbox[i]] = 1;
      }
      state.listLoading = true;
      let res = await exchangeGift({
        ...json,
        status: active.value,
        ex_gift_cate_id: search.value.ex_gift_cate_id[1],
      }).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        data.value = res.data.data;
        state.total = res.data.total;
        state.http = res.data.http;
        state.brand_id = res.data.brand_id;
      } else {
        message.error(res.msg);
      }
    };
    onMounted(() => {
      initData();
      initCate();
    });
    // 验证数组是否为空
    const verificationNull = (data) => {
      if (data instanceof Array && !data.length) {
        return true;
      }
      return false;
    };
    // 批量设置 运费模板
    const setShipping = () => {
      if (verificationNull(state.selectedRowKeys)) {
        message.error("请选择礼品");
        return;
      }
      state.freightVideoVisible = true;
    };
    // 选中运费模板
    const selectFreight = async (e) => {
      state.freightVideoVisible = false;
      //  参数 formData转化
      var formData = json2fromData({
        id: state.selectedRowKeys,
        delivery_id: e.id,
      });
      let result = await setDeliveryAll(formData)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        state.selectedRowKeys = [];
        initData();
      }
    };
    // 批量上架
    const pushShelf = (type, data) => {
      if (type == "single") {
        state.selectedRowKeys.push(data.id);
      } else {
        if (verificationNull(state.selectedRowKeys)) {
          message.error("请选择礼品");
          return;
        }
      }
      $Modal.confirm({
        centered: true,
        title: "上架确认",
        content: "您确定要立即上架吗？",
        onOk: async () => {
          handleShelf();
        },
        onCancel() {
          state.selectedRowKeys = [];
        },
      });
    };
    // 批量下架
    const offShelf = async (type, data) => {
      if (type == "single") {
        state.selectedRowKeys.push(data.id);
      } else {
        if (verificationNull(state.selectedRowKeys)) {
          message.error("请选择礼品");
          return;
        }
      }
      $Modal.confirm({
        centered: true,
        title: "下架确认",
        content: "您确定要立即下架吗？",
        onOk: async () => {
          handleShelf();
        },
        onCancel() {
          state.selectedRowKeys = [];
        },
      });
    };
    // 上下架确认
    const handleShelf = async () => {
      let result = await setExchangeState({
        id: state.selectedRowKeys,
        is_timing_status: 0,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        state.selectedRowKeys = [];
        initData();
      }
    };
    const setCateAll = () => {
      if (!state.selectedRowKeys.length) {
        message.error("请选择礼品");
        return false;
      }
      state.showEditCate = true;
    };
    // 批量设置分类
    const editCate = async () => {
      let result = await updateAllCate({
        category_id: state.valueCate[1],
        id: state.selectedRowKeys,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        state.showEditCate = false;
        state.valueCate = "";
        state.selectedRowKeys = [];
        initData();
      }
    };
    // 复制链接
    const copy = () => {
      let clipboard = new Clipboard(".copy-btn"); // 这里括号里填写上面点击事件绑定的class名
      clipboard.on("success", (e) => {
        message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
    };
    return {
      ...toRefs(state),
      copy,
      onSelectChange,
      options,
      search,
      data,
      columns,
      active,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      callback,
      reset,
      form,
      setShipping,
      pushShelf,
      offShelf,
      selectFreight,
      handleShelf,
      submitPrice,
      submitStock,
      editCate,
      setCateAll,
    };
  },
};
</script>